import React, { useEffect, useState } from "react";
import "./HotelBooking.scss";
import HotelSearchBar from "../../../containers/HotelSearchBar";
import { handleGetHotelCitySuggestionApiCall } from "../../../utils/ApiCalls";
import AvailHotelList from "../../../containers/AvailHotelList";

const HotelBooking = () => {
  const [availHotelList, setAvailHotelList] = useState(null);
  const [resultForData, setResultForData] = useState({
    city: "",
    checkIn: "",
    checkOut: "",
    adultCount: "",
    childrenCount: "",
    roomCount: "",
  });
  const [initialApiCall,setInitialApiCall] = useState(false);
  const hanldeSetAvailHotelList = (value) => {
    setAvailHotelList(value);
  };
  const handleSetResultForData = (value) => {
    setResultForData(value);
  };
  const handleSetInitialApiCall = (value) => {
    setInitialApiCall(value);
  }
  // console.log("availHotelList",availHotelList);
  return (
    <div className="HotelBooking">
      <div className="HotelBooking__container-1">
        <div className="content-wrapper">
          <h3>Search your hotels here...</h3>
          <HotelSearchBar
            hanldeSetAvailHotelList={hanldeSetAvailHotelList}
            handleSetResultForData={handleSetResultForData}
            handleSetInitialApiCall={handleSetInitialApiCall}
          />
        </div>
      </div>
      <div className="hotel_sticky_container">
        {
          initialApiCall ? 
          <AvailHotelList
            resultForData={resultForData}
            availHotelList={availHotelList}
            hanldeSetAvailHotelList={hanldeSetAvailHotelList}
          />
          :
          <div className="empty_content_wrapper">
            <p>Search for a hotel to get result</p>
          </div>
        }
        {/* {!availHotelList ? (
          <div>Loading...</div>
        ) : (
          <AvailHotelList
            resultForData={resultForData}
            availHotelList={availHotelList}
            hanldeSetAvailHotelList={hanldeSetAvailHotelList}
          />
        )} */}
      </div>
    </div>
  );
};

export default HotelBooking;
